import { getDeviceIdSuffix } from "@/utils/platform";

const STORAGE_KEY = "app_device_id";
const COOKIE_KEY = "app_device_id";
const LEGACY_SUFFIX_RE = /-(WEBUS|H5US)$/i;
const DEVICE_ID_RE = /^(.+)-(ANDROID|IOS|WEBUS|H5US)$/i;

function generateUUID() {
  let uuid = "";

  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    uuid = crypto.randomUUID();
  } else {
    uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  return `${uuid}-${getDeviceIdSuffix()}`;
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name, value) {
  const maxAge = 60 * 60 * 24 * 365;
  document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${maxAge}; path=/; SameSite=Lax`;
}

function persistDeviceId(deviceId) {
  setCookie(COOKIE_KEY, deviceId);
  try {
    localStorage.setItem(STORAGE_KEY, deviceId);
  } catch (e) {
    console.warn("localStorage 写入失败:", e);
  }
}

function syncDeviceIdSuffix(deviceId) {
  const expectedSuffix = getDeviceIdSuffix();
  const match = deviceId.match(DEVICE_ID_RE);

  if (!match || LEGACY_SUFFIX_RE.test(deviceId)) {
    const newDeviceId = generateUUID();
    persistDeviceId(newDeviceId);
    return newDeviceId;
  }

  const normalizedDeviceId = `${match[1]}-${expectedSuffix}`;
  if (normalizedDeviceId !== deviceId) {
    persistDeviceId(normalizedDeviceId);
  }

  return normalizedDeviceId;
}

/**
 * 获取或创建设备 ID（优先 cookie，fallback localStorage，最后生成新 ID）
 * @returns {string}
 */
export function getDeviceId() {
  const cookieId = getCookie(COOKIE_KEY);
  if (cookieId) {
    return syncDeviceIdSuffix(cookieId);
  }

  try {
    const localStorageId = localStorage.getItem(STORAGE_KEY);
    if (localStorageId) {
      return syncDeviceIdSuffix(localStorageId);
    }
  } catch (e) {
    console.warn("localStorage 读取失败:", e);
  }

  const newDeviceId = generateUUID();
  persistDeviceId(newDeviceId);

  return newDeviceId;
}
